/**
 * ページ読み込み完了後に URL ハッシュの要素へスクロールし直す
 *
 * サイズ未指定の画像が後から読み込まれると、ブラウザの初回アンカージャンプ後に
 * レイアウトがずれて目的のセクションから外れるため、load 後に位置を補正する。
 *
 * @returns {void}
 * @example
 * initHashScroll();
 */
const initHashScroll = (): void => {
  const { hash } = window.location;
  if (!hash) return;

  const target = document.getElementById(decodeURIComponent(hash.slice(1)));
  if (!target) return;

  window.addEventListener("load", () => {
    // html の scroll-behavior: smooth を上書きして即座に位置を合わせる
    target.scrollIntoView({ behavior: "instant", block: "start" });
  });
};

initHashScroll();
